module.exports = __webpack_public_path__ + "img/solar-side-down.fbe140aa.jpg";